export default __webpack_public_path__ + "static/media/topMenu_brightness.49fa346d.svg";